import { z } from 'zod';
import { apiEnvelope, backendDate, numericString, optionalDocument, optionalText, tonsToKg } from './backend.schema';

/** `YYYY-MM-DD` del backend a `DD/MM/YYYY`, el formato de las tablas. */
const toDisplayDate = (date: string) => date.slice(0, 10).split('-').reverse().join('/');

/**
 * Fila de `GET /seed-backoffice/salida` (`ws_SemTabSalida`); kilos como string y en toneladas.
 * El backend todavía no informa transportista, chofer, chasis ni acoplado: quedan `null`.
 */
export const SalidaApiSchema = z
  .object({
    PDespa_Turno: numericString,
    PDespa_Fecha: backendDate,
    PDespa_TotNeto: numericString,
    PDespa_NroRem: optionalDocument,
    PLote_Codigo: z.string(),
    Variedad: optionalText,
    Bolsones_Despachados: numericString,
    Kg_Lote: numericString,
    Destino_Nombre: optionalText,
  })
  .transform((s) => ({
    turno: String(s.PDespa_Turno),
    fecha: s.PDespa_Fecha ? toDisplayDate(s.PDespa_Fecha) : null,
    lote: s.PLote_Codigo,
    variedad: s.Variedad,
    bolsones: s.Bolsones_Despachados,
    desp: tonsToKg(s.PDespa_TotNeto),
    kg: tonsToKg(s.Kg_Lote),
    destino: s.Destino_Nombre,
    transportista: null as string | null,
    chofer: null as string | null,
    chasis: null as string | null,
    acoplado: null as string | null,
    remito: s.PDespa_NroRem,
  }));

/** `{ data: { items, Message } }`, o `{ data: { Message } }` sin filas. */
export const SalidasRespSchema = apiEnvelope(z.object({ items: z.array(SalidaApiSchema).optional() })).transform(
  (r) => r.data.items ?? [],
);

export type Salida = z.output<typeof SalidaApiSchema>;
